import { Fragment } from "react";

import MyGroupsSearchGridLarge from "./MyGroupsSearchGridLarge";
import MyGroupsSearchGridSmall from "./MyGroupsSearchGridSmall";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const MyGroupsSearchGrid = ({ gridData, isLoading, showFilters, onToggleShowFilters, onEditGroupClicked }) => (
  <Fragment>
    {isLoading === false
      ? (
        <div className="row">
          <div className="col-xs-12 col-sm-10">
            {gridData.length > 49
              ? <p className={global.ErrorMessage}>More than 50 Search Results returned. Please add additional filters to narrow your search results.</p>
              : <p>{gridData.length === 1 ? `${gridData.length} Search Result` : `${gridData.length} Search Results`}</p>
            }
          </div>
          <div className="col-xs-12 col-sm-2">
            <button className={global.ToggleButton} type="button" onClick={() => onToggleShowFilters()}>
              {showFilters === true ? 'Hide Filters' : 'Show Filters'}
            </button>
          </div>
        </div>
      ) : <div className="row usas-extra-top-margin usas-extra-bottom-margin"></div>
    }
    <MyGroupsSearchGridLarge gridData={gridData} isLoading={isLoading} onEditGroupClicked={onEditGroupClicked} />
    <MyGroupsSearchGridSmall gridData={gridData} isLoading={isLoading} onEditGroupClicked={onEditGroupClicked} />
  </Fragment>
);

export default MyGroupsSearchGrid;